import Vue from 'vue';
import Router from 'vue-router';
import store from './store';
import { GetCurUserInfo } from "@/request/common";
const Main = () => import('./views/main/main.vue');
const Access = () => import('./views/access/access.vue');
const Home = () => import('./views/home/home.vue');
const Keyan = () => import('./views/keyan/keyan.vue');
const Xunzheng = () => import('./views/xunzheng/xunzheng.vue');
import MainRouterChildren from './views/main/main.router';
import AccessRouterChildren from './views/access/access.router';
import HomeRouterChildren from './views/home/home.router';
import KeyanRouterChildren from './views/keyan/keyan.router';
import XunzhengRouterChildren from './views/xunzheng/xunzheng.router';
const Resources = () => import('./views/xunzheng/views/resources.vue');

Vue.use(Router);
/**
 * @description 通过获得localstorage来检测是否有token
 */
const checkLoggedIn = (): boolean => {
  let ifLoggedIn: boolean = false;
  const token: string | null = localStorage.getItem('token');
  const user: any = localStorage.getItem('user');
  if (user && token && typeof (token) === 'string') {
    store.commit("updateToken", token);
    // 获取用户信息
    GetCurUserInfo(this).then((res: any) => {
      store.commit("updateUser", res.data);
    })
    ifLoggedIn = true;
  }
  return ifLoggedIn;
};
const router = new Router({
  routes: [

    {
      path: '/access',
      component: Access,
      children: AccessRouterChildren
    },
    {
      path: '/home',
      component: Home,
      children: HomeRouterChildren
    },
    {
      path: '/keyan',
      component: Keyan,
      children: KeyanRouterChildren
    },
    {
      path: '/xunzheng',
      component: Xunzheng,
      children: XunzhengRouterChildren
    },
    {
      path: '/resources',
      name: 'resources',
      component: Resources
    },
    {
      path: '/main',
      name: 'main',
      component: Main,
      children: MainRouterChildren,
      beforeEnter: (to, from, next) => {
        const ifLoggedIn = checkLoggedIn();
        if (ifLoggedIn) {
          next();
        } else {
          next('/access/login');
        }
      }
    },
    {
      path: '*',
      redirect: '/home/folder',
    },
  ],
});

export default router;
